require('@babel/register');

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import FastClick from 'fastclick';
import deepForceUpdate from 'react-deep-force-update';

import configureStore from './redux/store/configureStore';
import startPersistingWhenIdentified from './redux/store/startPersistingWhenIdentified';
import sagas from './sagas';
import { appRoutes } from './routes';
import UserService from './services/keycloak';

import './styles/global.scss';

FastClick.attach(document.body);
const container = document.getElementById('app');

let initialState = localStorage.getItem('id_token')
  ? {
      authentication: { isAuthed: true }
    }
  : {
      authentication: { isAuthed: false }
    };

const { startPersisting, store } = configureStore(initialState);
store.runSaga(sagas);

let appInstance = () => {
  // FIN-13485: start redux-persist only when the current user is known — the persisted Case
  // Listing filters are restored for their owner only, and that check needs the identity. On a
  // boot with no session (Keycloak has redirected to login) no persistor exists, so nothing can
  // overwrite the stored entry; see redux/store/startPersistingWhenIdentified.js.
  const persistor = startPersistingWhenIdentified(store, startPersisting);
  const routes = appRoutes(store);
  ReactDOM.render(
    <Provider store={store}>
      {persistor ? (
        <PersistGate persistor={persistor}>{routes}</PersistGate>
      ) : (
        routes
      )}
    </Provider>,
    container
  );
};

UserService.initKeycloak(appInstance, store);

// Enable Hot Module Replacement (HMR)
if (module.hot) {
  module.hot.accept('./routes/', () => {
    if (appInstance) {
      try {
        // Force-update the whole tree, including components that refuse to update
        deepForceUpdate(appInstance);
      } catch (error) {
        appInstance = null;
        document.title = `Hot Update Error: ${error.message}`;
        ReactDOM.render(<ErrorReporter error={error} />, container);
        return;
      }
    }
  });
}
